module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('yjp-input-number', _vm._g(_vm._b({}, 'yjp-input-number', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-885cf84a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/NumberWidget.vue
// module id = 724
// module chunks = 20